import React from 'react';

const Twitter = () => (
  <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.11493 0L11.6651 15.4437L0.0419922 28H2.65789L12.8339 17.0067L21.0558 28H29.9578L17.7578 11.6877L28.5765 0H25.9606L16.589 10.1246L9.01692 0H0.11493ZM3.9618 1.92687H8.05139L26.1103 26.0728H22.0208L3.9618 1.92687Z"
      fill="white"
    />
  </svg>
);

export default Twitter;
